import Vue from 'vue'
import Vuex from 'vuex'

import app from './app'
import basic from './basic'
import application from './application'
import currentuser from './currentuser'

import i18n, {DefaultLanguage} from '@/locale'
Vue.use(Vuex)
Vue.use(i18n)

const store = new Vuex.Store({
  modules: {
    app,
    basic,
    currentuser,
    application
  },

  actions: {
    async init({dispatch}) {
      console.log('Store - init')
      await Promise.all([
        //- Things to do on app start (After API is up)
        dispatch('app/setApiVersion'),
        dispatch('currentuser/loadCurrentUser'),
        dispatch('loadCurrentLocale'),
        dispatch('onWasInitialized')
      ]).catch(error => {
        console.log('Error in init: ', error)
      })
    },

    onWasLoggedOut({dispatch}) {
      console.log('Store - onWasLoggedOut')

      //- Clear localstore
      localStorage.removeItem('user')

      //- User Was logged out
      return Promise.all([dispatch('currentuser/setCurrentUser', null)]).catch(error => {
        console.log('Error in logout: ', error)
      })
    },

    onWasInitialized({dispatch}) {
      console.log('Store - onWasInitialized')

      //- Set init flag
      return dispatch('app/setInitialized', true)
    },

    loadCurrentLocale({dispatch}) {
      console.log('loadCurrentLocale')
      // Grab user data from local storage
      const locale = localStorage.getItem('locale')
      i18n.locale = locale || DefaultLanguage
      // Set locale or default
      return dispatch('app/setLocale', locale || DefaultLanguage)
    }
  }
})

export default store
